import React from "react";
import { MapStateToPropsParam } from "react-redux";

import { MapDispatchToPropsObject } from "@/mk2/helpers/types";
import Page, { BrandingProps, HalfpageProps, PageRouteProps } from "@/mk2/pages/Page";
import { AppState } from "@/mk2/reducers";
import { Store } from "@/mk2/store/configureStore";
import { FOOTER_HELP_LINK } from "@/mk/autogenerated/translations/HelpRedirectPage.eb005c8cf38ae958b435c66d672eacc3";

import HelpRedirect from "./HelpRedirect";

interface OwnProps {}

interface StateProps {}

interface DispatchProps {}

type RouteProps = PageRouteProps<{}>;
export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class HelpRedirectPage extends Page<
    OwnProps & RouteProps,
    StateProps,
    DispatchProps
> {
    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            return {};
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {};
    }

    public getMetaTitle(props: Props): string {
        return FOOTER_HELP_LINK;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <div>
                <HelpRedirect {...props} />
            </div>
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return false;
    }

    public getBrandingProps(props: Props): BrandingProps {
        return null;
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        return null;
    }

    public registerInStore(store: Store<AppState>) {
        // intentionally empty
    }
}
